import { render, staticRenderFns } from "./MarkdownView.vue?vue&type=template&id=5db558f4&"
import script from "./MarkdownView.vue?vue&type=script&lang=ts&"
export * from "./MarkdownView.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownView.vue?vue&type=style&index=0&id=5db558f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports